import { gql } from '@apollo/client';

export * from './escrowTerminationRequest.mutation.generated';

export const ESCROW_TERMINATION_REQUEST = gql`
  mutation escrowTerminationRequest($escrowId: ID!) {
    escrowTerminationRequest(input: { escrowId: $escrowId }) {
      success
      errors
    }
  }
`;
